// User data model
export class User {
  constructor(data = {}) {
    this.id = data.id || generateId();
    this.name = data.name || 'Traveler';
    this.xp = data.xp || 0;
    this.level = data.level || 1;
    this.streakDays = data.streakDays || 0;
    this.lastActiveDate = data.lastActiveDate || new Date().toISOString();
    this.achievements = data.achievements || [];
    this.achievementVersion = Number.isFinite(data.achievementVersion) ? data.achievementVersion : 0;
    this.achievementState = data.achievementState || null;
    this.createdAt = data.createdAt || new Date().toISOString();
    
    // Buddy selection tracking
    this.hasSelectedBuddy = data.hasSelectedBuddy !== undefined ? data.hasSelectedBuddy : false;
    this.buddyPreferences = data.buddyPreferences || {
      favoriteAnimal: null,
      selectedEggColor: 'blue'
    };
    this.subscriptionTier = data.subscriptionTier || 'free';
    this.fitHistoryRetention = data.fitHistoryRetention || '12m';
    this.fitUnlimitedHistory = data.fitUnlimitedHistory === true;
    this.isPaidSubscriber = data.isPaidSubscriber === true;
  }

  addXP(amount) {
    this.xp += amount;
    this.checkLevelUp();
  }

  checkLevelUp() {
    const xpNeeded = this.getXPForNextLevel();
    if (this.xp >= xpNeeded) {
      this.level++;
      this.xp -= xpNeeded;
      return true; // Leveled up
    }
    return false;
  }

  getXPForNextLevel() {
    // Exponential scaling: level * 100 * 1.5^(level-1)
    return Math.floor(this.level * 100 * Math.pow(1.5, this.level - 1));
  }

  updateStreak() {
    const today = new Date().toDateString();
    const lastActive = new Date(this.lastActiveDate).toDateString();
    const yesterday = new Date(Date.now() - 86400000).toDateString();

    if (lastActive === today) {
      return; // Already updated today
    } else if (lastActive === yesterday) {
      this.streakDays++;
    } else {
      this.streakDays = 1; // Reset streak
    }
    this.lastActiveDate = new Date().toISOString();
  }
}

function generateId() {
  return `user_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
}
